/* eslint-disable max-statements */
import React, { ComponentType, ReactNode, useState } from 'react';
import compose from 'lodash/fp/compose';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withCustomer } from '@catalogo/core-connect/customer';
import { withMetrics } from '@catalogo/core-metrics';
import { useFreight } from '../hooks/freight';
import { useFreightLasa } from '../hooks/freight-lasa';
import { shouldCallFreight, getLasaOffer } from '../helpers/freight';
import { fmtFreightData, getLasaOfferTexts, toogleClick } from '../helpers/freight-v2';

type ObjectType = {
  [key: string]: string;
};

interface WithFreightV2Props {
  children: ReactNode;
  currentSku: ObjectType;
  cookies: ObjectType;
  page: ObjectType;
  product: ObjectType;
  dispatchMetrics(): void;
}

export const withFreightV2 = (Component: ComponentType) => (props: WithFreightV2Props) => {
  const { currentSku, cookies, page, dispatchMetrics, product } = props;
  const [click, setClick] = useState(false);
  const persistentCep = cookies?.persistentCep ?? '';
  const shouldCall = shouldCallFreight(page, 'FREIGHT_AUTO', click);
  const skip = !shouldCall || persistentCep.length < 8;
  const lasaOffer = getLasaOffer(currentSku, product);

  const { loading: freightLasaLoading, data: freightLasaData } = useFreightLasa({
    persistentCep,
    offer: lasaOffer,
    dispatchMetrics,
  });

  const { loading: freightLoading, data, error } = useFreight({
    cep: persistentCep,
    currentSku,
    dispatchMetrics,
    skip,
    cache: false,
  });

  const { freight, freightError, warningMessage, preSale, unified, international } = fmtFreightData({
    data,
    dataLasa: freightLasaData,
    currentSku,
    product,
    error,
  });

  let lasaOfferData;
  const { showLasaOffer } = freight ?? {};
  if (showLasaOffer) {
    const { salesPrice } = lasaOffer;
    const { freight: freightLasa } = freightLasaData;
    lasaOfferData = getLasaOfferTexts(freightLasa?.options, salesPrice);
  }

  const isLoading = (freightLoading || freightLasaLoading) && persistentCep?.length > 0;

  const freightProps = {
    freight,
    freightError,
    warningMessage,
    preSale,
    isLoading,
    showLoader: isLoading && freight?.options?.length === 0,
    toogleClick: toogleClick(click, setClick),
    shouldCall,
    unified,
    international,
    lasaOfferData,
    showContentFreight: freight?.options?.length > 0 || lasaOfferData,
  };

  return <Component {...freightProps} {...props} />;
};

export default compose(withCustomer, withCookies, withMetrics, withFreightV2);
